import React from 'react';
import Hero from '../Home/Hero';

const Home = () => {
    return (
        <>
            <Hero></Hero>
        </>

    );
};

export default Home;